/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import { Button, Card, Divider, Grid, Icon } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useDispatch, useSelector } from "react-redux";
import {
  InformacionCitas,
  AgregarCita,
  AgregarDocumentoCita,
  NotificarPacienteCita,
  NotificarMedicoCita,
  EliminarCita,
} from "store/tav/tavActions";
import { InformacionInicialCatalogos } from "store/catalogos/catalogosActions";
import { useEffect, useMemo, useState } from "react";
import TableDataProx from "./data/DataTableCitas";
import { find } from "lodash";
import { getSolicitudesT } from "store/solicitudes/solicitudesActions";
import FormNuevaCita from "./form/formNuevaCita";
import FormCargarDocumento from "./form/formCargarDocumento";
import Loading from "components/loading";
import ModalContent from "components/ModalContent";
import moment from "moment";
import "moment/locale/es"; // Importa el locale en español
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import _ from "lodash";
import { store } from "store/store";

function Citas({ idDetalleSolicitud, esExpediente }) {
  const route = useLocation().pathname.split("/").slice(1);
  const usuario = store.getState().login.usuario;
  const navigate = useNavigate();
  const { citas, isloadingCitas } = useSelector((state) => state.tav);
  const { estudiosMedicos } = useSelector((state) => state.catalogos);

  const dispatch = useDispatch();
  useEffect(() => {
    InformacionCitas(dispatch, idDetalleSolicitud);
    InformacionInicialCatalogos(dispatch);
  }, []);

  //Form nueva cita
  const [idEstudio, setIdEstudio] = useState(0);
  const [fechaCita, setFechaCita] = useState("");
  const [horaCita, setHoraCita] = useState(0);
  const [lugar, setLugar] = useState(0);
  const [idMedico, setIdMedico] = useState(0);
  const [observaciones, setObservaciones] = useState("");

  const [medicoNombre, setMedicoNombre] = useState("");
  const [nombreLugar, setNombreLugar] = useState("");
  const [disabledMedicos, setDisabledMedicos] = useState(true);

  //Form cargar documento
  const [idCita, setIdCita] = useState(0);
  const [tituloDoc, setTituloDoc] = useState("");
  const [documento, setDocumento] = useState(null);
  const [observacionesDoc, setObservacionesDoc] = useState("");
  const [estudioDoc, setEstudioDoc] = useState(null);

  const [rowSelect, setRowSelect] = useState({});

  const [openmodal, setopenmodal] = useState(false);
  const [openmodalDelete, setopenmodalDelete] = useState(false);
  const [openmodalCargarDoc, setOpenmodalCargarDoc] = useState(false);
  const [openmodalNotiP, setOpenmodalNotiP] = useState(false);
  const [openmodalNotiM, setOpenmodalNotiM] = useState(false);

  const refresh = () => {
    setIdEstudio(0);
    setLugar(0);
    setFechaCita("");
    setHoraCita("");
    setObservaciones("");
    setIdMedico(0);
    setopenmodal(false);
  };

  const refreshDoc = () => {
    setIdCita(0);
    setTituloDoc("");
    setDocumento(null);
    setObservacionesDoc("");
    setEstudioDoc(null);
    setOpenmodalCargarDoc(false);
  };

  const save = () => {
    const [hora, minuto] = horaCita.split(":").map(Number);

    var nuevaCita = {
      idEstudio: idEstudio,
      fechaCita: fechaCita,
      horaCita: hora,
      minutoCita: minuto,
      idHospital: lugar,
      idMedico: idMedico,
      observaciones: observaciones,
      idSolicitud: idDetalleSolicitud,
      precio: 0,
      hospital: nombreLugar,
    };

    const conflicto = citas.find((cita) => {
      const mismaFecha = moment(cita.fechaCita).isSame(nuevaCita.fechaCita, "day");
      const mismaHora = cita.horaCita === nuevaCita.horaCita;
      const mismoMinuto = cita.minutoCita === nuevaCita.minutoCita;

      const coincideFechaHora = mismaFecha && mismaHora && mismoMinuto;

      if (coincideFechaHora && cita.idSolicitud === nuevaCita.idSolicitud) {
        toast.error("Ya existe una cita registrada para este paciente en esa fecha y hora.");
        return true;
      }

      if (coincideFechaHora && cita.idMedico === nuevaCita.idMedico) {
        toast.error("Este médico ya tiene una cita registrada en esa fecha y hora.");
        return true;
      }

      return false;
    });

    if (conflicto) return;

    AgregarCita(dispatch, nuevaCita, false);
    setopenmodal(false);
    refresh();
  };

  const handleEliminarCita = async () => {
    const exito = await dispatch(
      EliminarCita({ idCita: rowSelect.idCita, idSolicitud: rowSelect.idSolicitud }, false)
    );
    setopenmodalDelete(!exito);
  };

  const saveDoc = () => {
    var datosCita = {
      IdSolicitud: idDetalleSolicitud,
      IdCita: idCita,
      IdUsuarioCarga: usuario.idUsuario,
      Observaciones: observacionesDoc,
      TituloDocumento: tituloDoc,
      Estudio: "",
      UserName: usuario.username,
      Archivo: documento,
    };

    // cargar el archivo
    AgregarDocumentoCita(dispatch, datosCita, false);
    setOpenmodalCargarDoc(false);
    refreshDoc();
  };

  const columnsCitas = useMemo(() => {
    if (!estudiosMedicos || estudiosMedicos.length === 0) return []; // evita renderizar columnas si no hay datos
    return [
      {
        header: "Fecha",
        size: 185,
        Cell: ({ row }) => {
          const fechaFormateada = moment(row.original.fechaCita).format(
            "dddd D [de] MMMM [de] YYYY"
          );

          return fechaFormateada;
        },
      },
      {
        accessorKey: "horaCompleta",
        header: "Hora",
        size: 90,
        Cell: ({ row }) => {
          return `${String(row.original.horaCita).padStart(2, "0")}:${String(
            row.original.minutoCita
          ).padStart(2, "0")} Hrs`;
        },
      },
      {
        accessorKey: "estudio",
        header: "Estudio",
        size: 300,
        Cell: ({ row }) => {
          return find(estudiosMedicos, { idEstudio: row.original.idEstudio })?.descripcion || "";
        },
      },
      {
        accessorKey: "hospital",
        header: "Lugar",
        size: 130,
      },
      {
        accessorKey: "medico",
        header: "Médico",
        size: 130,
        Cell: ({ row }) => {
          return row.original.idMedico == 0
            ? "No Asignado"
            : `${row.original.nombreMedico} ${row.original.apellidoPaternoMedico}`;
        },
      },
      {
        accessorKey: "observaciones",
        header: "Observaciones",
        size: 250,
      },
    ];
  }, [estudiosMedicos]);

  moment.locale("es");

  const ahora = moment();
  const citasAnteriores = citas.filter((cita) =>
    moment(cita.fechaCita)
      .set({
        hour: cita.horaCita,
        minute: cita.minutoCita,
        second: 0,
        millisecond: 0,
      })
      .isBefore(ahora)
  );

  const citasProximas = citas.filter((cita) =>
    moment(cita.fechaCita)
      .set({
        hour: cita.horaCita,
        minute: cita.minutoCita,
        second: 0,
        millisecond: 0,
      })
      .isSameOrAfter(ahora)
  );

  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const agregarCita = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente == 1 ? 77 : 30)
  );

  return (
    <>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox textAlign="right">
              {agregarCita.length == 0 ? null : (
                <Button
                  variant="contained"
                  startIcon={<Icon>add</Icon>}
                  onClick={() => {
                    setopenmodal(true);
                  }}
                  size="small"
                  color="primary"
                >
                  Nueva cita
                </Button>
              )}
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox textAlign="left">
              <Button
                variant="contained"
                startIcon={<Icon>calendar_month</Icon>}
                color="primary"
                size="small"
                style={{ textTransform: "inherit", background: "#1D1D1B" }}
                onClick={() => {
                  if (citas.length > 0) {
                    navigate("/calendarioCitas", {
                      state: {
                        citas: [...citasAnteriores, ...citasProximas],
                        ruta: "/" + route,
                      },
                    });
                  } else {
                    toast.error("No hay citas para ver en el calendario");
                  }
                }}
              >
                CALENDARIO DE CITAS
              </Button>
            </MDBox>
          </Grid>
        </Grid>

        <Divider />
        <MDBox pt={3}>
          {isloadingCitas || estudiosMedicos.length === 0 ? (
            <Loading title={"Cargando citas proximas, por favor espere."} />
          ) : citasProximas.length === 0 ? (
            <MDTypography variant="h6" color="white" sx={{ marginLeft: "15px" }}>
              NO HAY CITAS PRÓXIMAS PARA MOSTRAR
            </MDTypography>
          ) : (
            <TableDataProx
              columns={columnsCitas}
              data={citasProximas}
              tablaProx={true}
              EliminarCita={(dataCita) => {
                setRowSelect(dataCita);
                setopenmodalDelete(true);
              }}
              NotificarPaciente={(dataCita) => {
                setRowSelect(dataCita);
                setOpenmodalNotiP(true);
              }}
              NotificarMedico={(dataCita) => {
                setRowSelect(dataCita);
                setOpenmodalNotiM(true);
              }}
              esExpediente={esExpediente}
            />
          )}
        </MDBox>
        <Divider />
        <MDBox pt={3}>
          {isloadingCitas || estudiosMedicos.length === 0 ? (
            <Loading title={"Cargando citas anteriores, por favor espere."} />
          ) : citasAnteriores.length === 0 ? (
            <MDTypography variant="h6" color="white" sx={{ marginLeft: "15px" }}>
              NO HAY CITAS ATERIORES PARA MOSTRAR
            </MDTypography>
          ) : (
            <TableDataProx
              columns={columnsCitas}
              data={citasAnteriores}
              tablaProx={false}
              onCargarDoc={(row) => {
                setIdCita(row.idCita);
                setOpenmodalCargarDoc(true);
              }}
              esExpediente={esExpediente}
            />
          )}
          <Divider />
        </MDBox>
      </Grid>
      <ModalContent
        title={"Agregar Cita"}
        maxWidth="sm"
        fullWidth={true}
        open={openmodal}
        fullScreen={false}
        handleClose={refresh}
        handleAcept={save}
        textAccept="Agregar cita"
      >
        <FormNuevaCita
          props={{
            estudio: idEstudio,
            fechaCita: fechaCita,
            horaCita: horaCita,
            lugar: lugar,
            observaciones: observaciones,
            idMedico: idMedico,
            disabledMedicos: disabledMedicos,
          }}
          onChangeCita={(value, campo) => {
            if (campo === "estudio") setIdEstudio(value);
            if (campo === "fechaCita") setFechaCita(value);
            if (campo === "horaCita") setHoraCita(value);
            if (campo === "observaciones") setObservaciones(value);
            if (campo === "lugar") setLugar(value);
            if (campo === "nombreLugar") setNombreLugar(value);
            if (campo === "idMedico") setIdMedico(value);
            if (campo === "medico") setMedicoNombre(value);
            if (campo === "disabled") setDisabledMedicos(value);
          }}
        />
      </ModalContent>
      <ModalContent
        title={"Eliminar cita"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodalDelete}
        fullScreen={false}
        handleClose={() => {
          setopenmodalDelete(false);
        }}
        handleAcept={() => {
          handleEliminarCita();
        }}
        textAccept={"Eliminar"}
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            ¿Desea eliminar la cita del paciente{" "}
            <strong>
              {rowSelect.nombreCandidato} {rowSelect.aPaternoCandidato}{" "}
              {rowSelect.aMaternoCandidato}
            </strong>
            ?
          </MDTypography>
        </MDBox>
      </ModalContent>
      <ModalContent
        title={"Cargar valoración a la cita"}
        maxWidth="sm"
        fullWidth={true}
        open={openmodalCargarDoc}
        fullScreen={false}
        handleClose={refreshDoc}
        handleAcept={saveDoc}
        textAccept="Cargar valoración"
      >
        <FormCargarDocumento
          props={{
            tituloDoc: tituloDoc,
            documento: documento,
            observacionesDoc: observacionesDoc,
          }}
          onChangeDoc={(value, campo) => {
            if (campo === "tituloDoc") setTituloDoc(value);
            if (campo === "documento") setDocumento(value);
            if (campo === "observaciones") setObservacionesDoc(value);
          }}
        />
      </ModalContent>
      <ModalContent
        title={"Notificar Paciente"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodalNotiP}
        fullScreen={false}
        handleClose={() => {
          setOpenmodalNotiP(false);
        }}
        handleAcept={() => {
          NotificarPacienteCita(rowSelect.idSolicitud);
          setOpenmodalNotiP(false);
        }}
        textAccept={"Notificar paciente"}
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            ¿Desea notificar al paciente{" "}
            <strong>
              {rowSelect.nombreCandidato} {rowSelect.aPaternoCandidato}{" "}
              {rowSelect.aMaternoCandidato}
            </strong>{" "}
            sobre su cita con el médico{" "}
            <strong>
              {rowSelect.nombreMedico} {rowSelect.apellidoPaternoMedico}
            </strong>
            ?
          </MDTypography>
        </MDBox>
      </ModalContent>
      <ModalContent
        title={"Notificar Médico"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodalNotiM}
        fullScreen={false}
        handleClose={() => {
          setOpenmodalNotiM(false);
        }}
        handleAcept={() => {
          var data = {
            idSolicitud: rowSelect.idSolicitud,
            fechaCliente: moment().format("YYYY-MM-DD"),
          };
          NotificarMedicoCita(data);
          setOpenmodalNotiM(false);
        }}
        textAccept={"Notificar médico"}
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            <strong>
              {rowSelect.nombreMedico} {rowSelect.apellidoPaternoMedico}
            </strong>{" "}
            sobre su cita con el paciente{" "}
            <strong>
              {rowSelect.nombreCandidato} {rowSelect.aPaternoCandidato}{" "}
              {rowSelect.aMaternoCandidato}
            </strong>
            ?
          </MDTypography>
        </MDBox>
      </ModalContent>
    </>
  );
}

export default Citas;
